module.exports = __webpack_public_path__ + "img/kf.4a73366b.jpg";